import { ProductID } from '../../lib/ProductID';

export const defaultProductOrder = {
  productId: ProductID.MembershipWithRoadsideAssistance,
  amount: 1,
  isHouseholdProduct: true,
};
